export default function($) {
  $('.cssAnimate').waypoint(function (direction) {
    if( $(window).width() >= 768 ) {
      if ($(this.element).hasClass('services-left-block-js')) {
        $(this.element).addClass('animate-in slide-in-from-left-12 fade-in duration-1500').removeClass('cssAnimate');
      }
      if ($(this.element).hasClass('services-right-block-js')) {
        $(this.element).addClass('animate-in slide-in-from-bottom-12 fade-in duration-1500').removeClass('cssAnimate');
      }
    }
    if ($(this.element).hasClass('quote-js')) {
      $(this.element).addClass('animate-in slide-in-from-bottom-12 fade-in duration-1000').removeClass('cssAnimate');
    }
  }, { offset: '80%' });
}
